// /* eslint-disable no-else-return */
// import React, { useState } from 'react';
// import { RiArrowDownSLine } from 'react-icons/ri';
// import { Input } from 'reactstrap';

// const StatusFormatter = ({
//   options,
//   defaultValue,
//   handleChange = () => {},
//   isDisabledOption = false,
//   inputDisabled = false,
//   isStatus = false,
//   style = {},
//   handleSelectColor = () => {},
//   ...rest
// }) => {
//   const [selectValue, setSelectValue] = useState(defaultValue);
//   let disabledIndex = 0;
//   if (isDisabledOption) {
//     disabledIndex = options.findIndex((item) => item?.value === defaultValue);
//   }
//   const onSelectChange = (e) => {
//     setSelectValue(e.target.value);
//     handleChange(e);
//   };

//   return (
//     <div
//       className={`position-relative table-status ${isStatus ? handleSelectColor(selectValue) : ''}`}
//       style={style}
//     >
//       <RiArrowDownSLine size={18} className="sts-selct-arrow" />
//       <Input
//         className="f-12 shadow-none status-field"
//         id="status"
//         name="status"
//         type="select"
//         // style={style}
//         value={selectValue}
//         onChange={onSelectChange}
//         disabled={inputDisabled}
//         {...rest}
//       >
//         {options.map((item, index) => {
//           const isDisabled = index <= disabledIndex;
//           return (
//             <option
//               key={item.value}
//               value={item.value}
//               disabled={isDisabledOption ? isDisabled : isDisabledOption} // Conditionally set disabled attribute
//             >
//               {item.label}
//             </option>
//           );
//         })}
//       </Input>
//     </div>
//   );
// };

// export default StatusFormatter;

/* eslint-disable no-else-return */
import React, { useEffect, useState } from 'react';
import { RiArrowDownSLine } from 'react-icons/ri';
import { Input } from 'reactstrap';

const StatusFormatter = ({
  options,
  defaultValue,
  handleChange = () => {},
  isDisabledOption = false,
  inputDisabled = false,
  isStatus = false,
  style = {},
  handleSelectColor = () => {},
  title = '', // New prop for tooltip
  ...rest
}) => {
  const [selectValue, setSelectValue] = useState(defaultValue);
  let disabledIndex = 0;

  useEffect(() => {
    setSelectValue(defaultValue);
  }, [defaultValue]);

  if (isDisabledOption) {
    disabledIndex = options.findIndex((item) => item?.value === defaultValue);
  }

  const onSelectChange = (e) => {
    const newValue = e.target.value;
    setSelectValue(newValue);
    handleChange(e);
  };

  return (
    <div
      className={`position-relative table-status ${isStatus ? handleSelectColor(selectValue) : ''}`}
      style={style}
      title={title} // Tooltip show करने के लिए
    >
      <RiArrowDownSLine size={18} className="sts-selct-arrow" />
      <Input
        className="f-12 shadow-none status-field"
        id="status"
        name="status"
        type="select"
        value={selectValue}
        onChange={onSelectChange}
        disabled={inputDisabled}
        {...rest}
      >
        {options.map((item, index) => {
          const isDisabled = index <= disabledIndex;
          return (
            <option
              key={item.value}
              value={item.value}
              disabled={isDisabledOption ? isDisabled : isDisabledOption}
            >
              {item.label}
            </option>
          );
        })}
      </Input>
    </div>
  );
};

export default StatusFormatter;
